import React from 'react';

const RequestIcon: React.FC = (): React.ReactElement => {
  return (
    <>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <g id="Navigation/Request">
          <path
            id="Combined Shape"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.99959 2.625C8.29344 3.56512 7.875 4.73369 7.875 6C7.875 9.1066 10.3934 11.625 13.5 11.625C13.8853 11.625 14.2615 11.5863 14.625 11.5125V18.375H3.375V2.625H8.99959ZM10.1245 1.5H2.25V19.5H15.75V11.157C17.7366 10.2889 19.125 8.30661 19.125 6C19.125 2.8934 16.6066 0.375 13.5 0.375C12.2334 0.375 11.0647 0.793601 10.1245 1.5ZM15.75 2.10202C17.0951 2.88009 18 4.33436 18 6C18 7.66564 17.0951 9.11991 15.75 9.89798L15.7399 9.9038C15.3945 10.1024 15.0203 10.2565 14.625 10.3582C14.2654 10.4508 13.8885 10.5 13.5 10.5C11.0147 10.5 9 8.48528 9 6C9 4.65597 9.58922 3.44956 10.5234 2.625C10.5609 2.59191 10.599 2.55943 10.6376 2.52758C11.4154 1.88563 12.4127 1.5 13.5 1.5C14.3196 1.5 15.0881 1.71914 15.75 2.10202ZM4.5 16.125H11.8125V17.25H4.5V16.125ZM13.5 13.5938H4.5V14.7188H13.5V13.5938ZM4.5 11.0625H9V12.1875H4.5V11.0625ZM16.429 4.71025L15.6335 3.91475L12.6562 6.89156L11.3665 5.60225L10.571 6.39775L12.6562 8.483L16.429 4.71025Z"
            fill="white"
          />
        </g>
      </svg>
    </>
  );
};

export default RequestIcon;
